import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/modules/account/templates/forgot-password-template.tsx");
